<template>
  <!-- <el-dialog
    top="4vh"
    v-model="isVisible"
    :close-on-click-modal="true"
    :align-center="false"
  >

    <div>
      <component :is="component"></component>
    </div>
  </el-dialog> -->
  <el-drawer v-model="isVisible" :with-header="false">
    <div>
      <component
        :is="component"
        :fileType="data.fileType"
        :showAddButton="data.showAddButton"
        :handleAddFile="data.handleAddFile"
      ></component>
    </div>
  </el-drawer>
</template>


<script setup lang="ts">
import { usePopupState } from "@/stores/popupState";
import { markRaw, watch } from "vue";
import { storeToRefs } from "pinia";

const store = usePopupState();
const { isVisible, component, data } = storeToRefs(store);

const handleClose = () => {
  store.hidePopup();
};

watch(isVisible, (newVal) => {
  console.log(
    "listening to store with value",
    newVal,
    "component",
    component,
    "data",
    data.value
  );
  if (!newVal) {
    store.hidePopup();
  }
});
</script>
<style>
.el-drawer__body {
  padding-top: 0.5rem;
}
</style>
